import React from 'react';
import PropTypes from 'prop-types';
import './ProgressBar.scss';

const ProgressBar = ({ completedPercentage, filename, status }) => (
  <div className="str-progress-bar" data-testid="progress-bar">
    <div className="str-progress-bar__text">
      {status}
      <div className="str-progress-bar__filename">{filename}</div>
      <div
        className="str-progress-bar__foreground"
        style={{ width: completedPercentage + '%' }}
      />
    </div>
  </div>
);

ProgressBar.propTypes = {
  completedPercentage: PropTypes.number.isRequired,
  filename: PropTypes.string.isRequired,
  status: PropTypes.string
};

ProgressBar.defaultProps = {
  status: 'uploading'
}

export default ProgressBar;
